module.exports = "<p>\n  tpvok works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tpvok/tpvok.component.html
// module id = ./src/app/components/tpvok/tpvok.component.html
// module chunks = main